import type { GlobalMenu } from "./types";

const STAGE_ICON_BASE =
  "https://stg-contents.crosstoken.io/frontend/common/app-launcher/icons";
const PROD_ICON_BASE =
  "https://contents.crosstoken.io/frontend/common/app-launcher/icons";

function icon(env: "stage" | "production", name: string): string {
  const base = env === "production" ? PROD_ICON_BASE : STAGE_ICON_BASE;
  return `${base}/${name}.png`;
}

export function getFallbackGlobalMenu(env: "dev" | "stage" | "production"): GlobalMenu {
  const iconEnv = env === "production" ? "production" : "stage";

  return {
    version: "0.0.1-fallback",
    items: [
      {
        id: "gametoken-cross",
        label: "Gametoken",
        description: "Trade game tokens easily using CROSS.",
        url: {
          dev: "https://stg.onechain.nexus/gametoken",
          stage: "https://stg.onechain.nexus/gametoken",
          production: "https://www.onechain.nexus/gametoken",
        },
        iconUrl: icon(iconEnv, "game-token"),
        order: 1000,
        type: "gametoken",
        badge: null,
        isNew: false,
        serviceStatus: "available",
      },
      {
        id: "forge",
        label: "Forge",
        description: "Launch Your Game, Ignite the Market",
        url: {
          dev: "https://stg.onechain.nexus/forge",
          stage: "https://stg.onechain.nexus/forge",
          production: "https://onechain.nexus/forge",
        },
        iconUrl: icon(iconEnv, "forge"),
        order: 4000,
        type: "forge",
        badge: null,
        isNew: true,
        serviceStatus: "available",
      },
      {
        id: "crossd",
        label: "Bridge",
        description: "The first decentralized exchange on the CROSS network.",
        url: {
          dev: "https://stg.crossdefi.io/swap-bridge",
          stage: "https://stg.crossdefi.io/swap-bridge",
          production: "https://www.crossdefi.io/swap-bridge",
        },
        iconUrl: icon(iconEnv, "crossd"),
        order: 5000,
        type: "crossd",
        badge: null,
        isNew: false,
        serviceStatus: "ending",
      },
      {
        id: "onepop",
        label: "ONEpop",
        description: "Send crypto with just an X handle.",
        url: {
          dev: "https://dev.onechain.nexus/pop",
          stage: "https://stg.onechain.nexus/pop",
          production: "https://onechain.nexus/pop",
        },
        iconUrl:
          iconEnv === "production"
            ? "https://contents.onechain.nexus/frontend/common/app-launcher/icons/onepop.png"
            : "https://stg-contents.onechain.nexus/frontend/common/app-launcher/icons/onepop.png",
        order: 5500,
        type: "onepop",
        badge: null,
        isNew: true,
        serviceStatus: "available",
      },
      {
        id: "prediction",
        label: "Prediction",
        description: "Prediction market",
        url: {
          dev: "https://stg-prediction.crossdefi.io",
          stage: "https://stg-prediction.crossdefi.io",
          production: "https://prediction.crossdefi.io/",
        },
        iconUrl: icon(iconEnv, "prediction"),
        order: 6000,
        type: "prediction",
        badge: null,
        isNew: true,
        serviceStatus: "available",
      },
      {
        id: "rewards",
        label: "Rewards",
        description: "Deposit CROSS and earn rewards. Grow together.",
        url: {
          dev: "https://stg.onechain.nexus/rewards",
          stage: "https://stg.onechain.nexus/rewards",
          production: "https://onechain.nexus/rewards",
        },
        iconUrl: icon(iconEnv, "reward"),
        order: 7000,
        type: "rewards",
        badge: null,
        isNew: false,
        serviceStatus: "ending",
      },
      {
        id: "cross-staking",
        label: "Staking",
        description: "Stake CROSS and earn rewards.",
        url: {
          dev: "https://stg-stake.ogfcorp.com",
          stage: "https://stg-stake.ogfcorp.com",
          production: "https://stake.ogfcorp.com",
        },
        iconUrl: icon(iconEnv, "cross-staking"),
        order: 7500,
        type: "cross-staking",
        badge: null,
        isNew: true,
        serviceStatus: "available",
      },
      {
        id: "nft",
        label: "NFT",
        description: "Trade and collect NFTs in the CROSS ecosystem.",
        url: {
          dev: "https://stg.crossnft.io/",
          stage: "https://stg.crossnft.io/",
          production: "https://www.crossnft.io/",
        },
        iconUrl: icon(iconEnv, "nft"),
        order: 8000,
        type: "nft",
        badge: null,
        isNew: false,
        serviceStatus: "available",
      },
      {
        id: "play",
        label: "Quest",
        description: "Discover and play games on CROSS.",
        url: {
          dev: "https://stg.onechain.nexus/quest",
          stage: "https://stg.onechain.nexus/quest",
          production: "https://www.onechain.nexus/quest",
        },
        iconUrl: icon(iconEnv, "play"),
        order: 8500,
        type: "play",
        badge: null,
        isNew: true,
        serviceStatus: "available",
      },
      {
        id: "shop",
        label: "Shop",
        description: "Game Payment Platform & In-Game Currency Store.",
        url: {
          dev: "https://stg.onechain.nexus/shop",
          stage: "https://stg.onechain.nexus/shop",
          production: "https://www.onechain.nexus/shop",
        },
        iconUrl: icon(iconEnv, "shop"),
        order: 9000,
        type: "shop",
        badge: null,
        isNew: false,
        serviceStatus: "available",
      },
      {
        id: "explorer",
        label: "Explorer",
        description: "View transactions, blocks, and token data on the CROSS network.",
        url: {
          dev: "https://stg-explorer.onechain.nexus",
          stage: "https://stg-explorer.onechain.nexus",
          production: "https://explorer.onechain.nexus",
        },
        iconUrl: icon(iconEnv, "explorer"),
        order: 12000,
        type: "explorer",
        badge: null,
        isNew: false,
        serviceStatus: "available",
      },
      {
        id: "wave",
        label: "Wave",
        description: "Stream, support, and earn in the CROSS ecosystem.",
        url: {
          dev: "https://stg.onechain.nexus/wave",
          stage: "https://stg.onechain.nexus/wave",
          production: "https://www.onechain.nexus/wave",
        },
        iconUrl: icon(iconEnv, "wave"),
        order: 110000,
        type: "wave",
        badge: null,
        isNew: false,
        serviceStatus: "available",
      },
    ],
  };
}
